module.exports = __webpack_public_path__ + "img/icon_history.bd35de8b.svg";